export const defaultGiftCardDomainState = {
    giftCardDetails: undefined
};
